export default __webpack_public_path__ + "static/media/phaphrom_img2.2cc0d017.webp";